import { FC } from 'react';

export const profileComponent = (component: FC<any>) => {
    return component;
};
